// Vendor
import * as React from 'react';
import Helmet from 'react-helmet';
import { graphql, useStaticQuery } from 'gatsby';

// Internal
import favicon from '@src/data/images/tu_favicon2.ico';

const BaseHelmet: React.FC = () => {
  const { ogImageDefault, site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            author
            description
            lang
            siteUrl
            title
          }
        }
        ogImageDefault: file(absolutePath: { regex: "/data/og-image/" }) {
          childImageSharp {
            fixed(height: 880, width: 1760) {
              src
            }
          }
        }
      }
    `
  );

  const { siteMetadata } = site;
  const { author, description, lang, siteUrl, title } = siteMetadata;
  const ogImage = siteUrl.concat(ogImageDefault.childImageSharp.fixed.src);

  return (
    <Helmet
      htmlAttributes={{ lang }}
      link={[{ rel: 'icon', href: favicon }]}
      meta={[
        {
          name: 'description',
          content: description
        },
        {
          property: 'og:description',
          content: description
        },
        {
          property: 'og:image',
          content: ogImage
        },
        {
          property: 'og:image:alt',
          content: 'Resale Report 2020'
        },
        {
          content: '880',
          property: 'og:image:height'
        },
        {
          property: 'og:image:secure_url',
          content: ogImage
        },
        {
          content: 'image/jpeg',
          property: 'og:image:type'
        },
        {
          property: 'og:image:url',
          content: ogImage
        },
        {
          content: '1760',
          property: 'og:image:width'
        },
        {
          property: 'og:title',
          content: title
        },
        {
          property: 'og:type',
          content: 'website'
        },
        {
          property: 'og:url',
          content: 'https://www.thredup.com/resale/'
        },
        {
          name: 'twitter:card',
          content: 'summary'
        },
        {
          name: 'twitter:creator',
          content: author
        },
        {
          name: 'twitter:description',
          content: description
        },
        {
          name: 'twitter:title',
          content: title
        }
      ]}
      title={'thredUP'}
      titleTemplate={`${title} | %s`}
    />
  );
};

export { BaseHelmet };
